import { useStore } from '@lib/context/store-context';
import { ButtonPrimary } from '@modules/common/components/form/buttons/button-primary';
import { ButtonSecondary } from '@modules/common/components/form/buttons/button-secondary';
import { useCart } from 'medusa-react';
import { useEffect, useState } from 'react';
import { Bounce, toast } from 'react-toastify';
import Link from 'next/link';
import { GenerateAdRollScript, PixelImg } from '@modules/common/components/yelp-pixel/yelp-pixel';
import { CARD_PROGRAMS } from '@lib/constants';
import { LET_THEM_CHOOSE } from '@lib/constants/variants';
import { useAvailableCyoThemeCards } from '@lib/hooks/use-availableCyoThemeCards';

type Props = {
  disabled?: boolean;
  businessName?: string;
  isDisabledButton?: boolean;
};

const RESTAURANTS_CHOICE_MESSAGE = 'Restaurant of Their Choice';
const SPAS_SALONS_CHOICE_MESSAGE = 'Spa or Salon of Their Choice';

const ButtonGroupBuyAdd = (props: Props) => {
  const { totalItems } = useCart();
  const { disabled, businessName, isDisabledButton } = props;
  const { setLoading, setBuyNow } = useStore();
  const [lastCount, setLastCount] = useState<number>(totalItems);
  const { giftCardTypesText } = useAvailableCyoThemeCards();
  const [ isClicked, setIsClicked ] = useState(false);

  useEffect(() => {
    if (totalItems > 1 && totalItems === lastCount + 2 && isClicked) {
      let CHOICE_MESSAGE = RESTAURANTS_CHOICE_MESSAGE;
      const showToast = (message: JSX.Element, isError: boolean = true) => {
        toast[isError ? 'error' : 'success'](message, {
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          transition: isError ? undefined : Bounce,
        });
      };
      if (typeof window !== 'undefined') {
        const cardProgram = sessionStorage.getItem(CARD_PROGRAMS.KEY);
        CHOICE_MESSAGE = `${giftCardTypesText?.[cardProgram ?? 'choose_your_own_restaurant']} Card`;
      }
      showToast(
        <div>
          {businessName && businessName != LET_THEM_CHOOSE ? businessName : CHOICE_MESSAGE} added to cart
          <br />
          <div className="static-content">
            <Link href="/cart" prefetch={false}>
              Go To Cart
            </Link>
          </div>
        </div>,
        false
      );

      setLastCount(totalItems);
      setIsClicked(false);
    }
  }, [totalItems, isClicked]);

  return (
    <div className="flex flex-row-reverse md:flex-row gap-5">
      <div className="card__form__action__button">
        <ButtonSecondary
          id="add-to-cart"
          size="medium"
          type="submit"
          variant="optimus_prime"
          onClick={() => {
            if (!disabled) {
              setBuyNow(false);
              GenerateAdRollScript({ segment_name: 'c88a3a05' });
            }
            setIsClicked(true);
          }}
          className={`!max-h-[42px] ${isDisabledButton ? 'buttonSecondary--disabled' : ''}`}
          disabled={isDisabledButton}
        >
          Add to Cart
          <PixelImg src="ct=0:ws9tka3&fmt=3" />
        </ButtonSecondary>
      </div>
      <div className="card__form__action__button">
        <ButtonPrimary
          id="buy-now"
          size="medium"
          type="submit"
          onClick={() => {
            if (!disabled) {
              setBuyNow(true);
              setLoading(true);
            }
            setIsClicked(true);
          }}
          variant="primary"
          className={`${isDisabledButton ? 'ButtonPrimary--disabled' : ''}`}
          disabled={isDisabledButton}
        >
          Buy Now!
        </ButtonPrimary>
      </div>
    </div>
  );
};

export default ButtonGroupBuyAdd;
